// extracted by mini-css-extract-plugin
export default {"rootClassName":"ImagePreviewWithLabel_rootClassName__Qyzy-"};